import { Component, EventEmitter, Output } from "@angular/core";

import { getImageFromFile } from "../util/image-file.util";
import { MatFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "image-upload-button",
    template: `
        @if (isAndroid()) {
            <input style="display: none" type="file" accept="image/*" capture="environment" (change)="onFileChanged($event)" #imageCapture />
            <input style="display: none" type="file" accept="image/*,.pdf" multiple (change)="onFileChanged($event)" #fileInput />

            <button mat-fab type="button" color="primary" matTooltip="Upload filer" matTooltipPosiotion="above" (click)="fileInput.click()">
                <mat-icon svgIcon="file-document"></mat-icon>
            </button>

            <button mat-fab type="button" color="primary" matTooltip="Tilføj billede" matTooltipPosiotion="above" (click)="imageCapture.click()">
                <mat-icon svgIcon="camera-plus"></mat-icon>
            </button>
        } @else {
            <input style="display: none" type="file" accept="image/*,.pdf,capture=camera" multiple (change)="onFileChanged($event)" #fileInput />
            <button mat-fab type="button" color="primary" matTooltip="Tilføj billede" matTooltipPosiotion="above" (click)="fileInput.click()">
                <mat-icon svgIcon="camera-plus"></mat-icon>
            </button>
        }
    `,
    styles: [
        `
            :host {
                display: flex;
                justify-content: space-around;
            }
        `
    ],
    imports: [MatFabButton, MatIcon]
})
export class ImageUploadButtonComponent {
    @Output() public add = new EventEmitter<NoteBilagPDF | HTMLImageElement>();

    public isAndroid(): boolean {
        return /Android/i.test(navigator.userAgent);
    }

    public onFileChanged(event: any): void {
        [...event.target.files].map((file: any) => {
            if (file.type === "application/pdf") {
                const reader = new FileReader();
                reader.onload = (ev: any) => {
                    const pdf = new Blob([ev.target.result], { type: "application/pdf" });
                    const pdfFile: NoteBilagPDF = {
                        filNavn: file.name,
                        fil: pdf
                    };
                    this.add.emit(pdfFile);
                };

                reader.readAsArrayBuffer(file);
                return;
            } else {
                getImageFromFile(file).then((image) => {
                    this.add.emit(image as HTMLImageElement);
                });
            }
        });
        console.log("Filer valgt:", event.target.files);
        event.target.value = ""; // Ellers reagerer feltet ikke på at man indsætter samme billede to gange.
    }
}

interface NoteBilagPDF {
    filNavn: string;
    fil: Blob;
}
